import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BLOGS_ROUTES } from './blogs.routes';
import { SharedModule } from '../shared/shared.module';
import { BlogsComponent } from './blogs.component';
import { BlogsService } from './blogs.service';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TextBoxModule } from '@progress/kendo-angular-inputs';
import { NgxEditorModule } from 'ngx-editor';
import { LabelModule } from '@progress/kendo-angular-label';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { PendingChangesGuard } from '../shared/pending-changes.guard';

@NgModule({
  imports: [
    RouterModule.forChild(BLOGS_ROUTES),
    SharedModule,
    NgSelectModule,
    FormsModule,
    ReactiveFormsModule,
    TextBoxModule,
    NgxEditorModule,
    LabelModule,
    DropDownsModule
  ],
  declarations: [
    BlogsComponent
  ],
  providers: [
    BlogsService,
    PendingChangesGuard
  ]
})
export class BlogsModule { }
